import baseAssignValue from "./_baseAssignValue.js";
import eq from "./eq.js";
function assignMergeValue(object, key, value) {
  (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) && baseAssignValue(object, key, value);
}
export {
  assignMergeValue as default
};
//# sourceMappingURL=_assignMergeValue.js.map
